module.exports = __webpack_public_path__ + "img/19.0347619e.png";